import formMainHubThirdPartyAuthProviderSetup from './formMainHubThirdPartyAuthProviderSetup';
import formAppThirdPartyAuthProviderAppearance from './formAppThirdPartyAuthProviderAppearance';
import formAppThirdPartyAuthProviderUserCodeView from './formAppThirdPartyAuthProviderUserCodeView';
import formAppThirdPartyAuthProviderUserManagement from './formAppThirdPartyAuthProviderUserManagement';
export default {
  title: 'Blocking Provider',
  attributeName:'thirdPartyAuthProvider',
  createURL: '',
  sessionParams: [],
  updateURL: 'mainHubs/mainHubId/thirdPartyProviders',
  createURL: 'mainHubs/mainHubId/thirdPartyProviders',
  sessionParams: ['mainHubId'],
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  idUpdate:true,
  noUpdateWithId: false,
  autoUpdate: false,
  formConfig: [
    formMainHubThirdPartyAuthProviderSetup,
    formAppThirdPartyAuthProviderAppearance,    
    formAppThirdPartyAuthProviderUserManagement,
    formAppThirdPartyAuthProviderUserCodeView
  ],
};
